import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL, DASHBOARD_URL, readApiResponse } from '../services/authApi';
import { pageStyle, cardStyle, brandStyle, titleStyle, textStyle, labelStyle, inputStyle, buttonStyle, secondaryButtonStyle, errorStyle, successStyle, helperLinkStyle } from './components/authPageStyles';

function AtivarConta() {
  const params = new URLSearchParams(window.location.search);
  const tokenFromUrl = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const hasToken = useMemo(() => tokenFromUrl.trim().length > 20, [tokenFromUrl]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!hasToken) return setError('Link de ativação inválido ou sem token. Solicite um novo convite ao administrador.');
    if (password.length < 6) return setError('A senha precisa ter pelo menos 6 caracteres.');
    if (password !== confirmPassword) return setError('As senhas não conferem.');

    setIsSubmitting(true);
    try {
      await fetch(`${API_BASE_URL}/api/auth/activate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: tokenFromUrl, password }),
      }).then(readApiResponse);

      setSuccess('Conta ativada com sucesso! Agora você já pode acessar o dashboard com seu e-mail e a senha criada.');
      setPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err.message || 'Não foi possível ativar sua conta.');
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main style={pageStyle}>
      <section style={cardStyle}>
        <div style={brandStyle}>RE</div>
        <h1 style={titleStyle}>Ativar conta</h1>
        <p style={textStyle}>Defina sua senha para concluir a ativação da conta e liberar o acesso ao painel RealEnergy.</p>
        {!hasToken && <div style={errorStyle}>Link de ativação inválido. Confira se você abriu o link completo recebido por e-mail.</div>}
        {error && <div style={errorStyle}>{error}</div>}
        {success && <div style={successStyle}>{success}</div>}

        {!success ? (
          <form onSubmit={handleSubmit}>
            <label style={labelStyle}>Nova senha</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Digite sua nova senha" style={inputStyle} autoComplete="new-password" />
            <label style={labelStyle}>Confirmar senha</label>
            <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Repita sua nova senha" style={inputStyle} autoComplete="new-password" />
            <button type="submit" disabled={isSubmitting || !hasToken} style={{ ...buttonStyle, opacity: isSubmitting || !hasToken ? 0.7 : 1 }}>{isSubmitting ? 'Ativando conta...' : 'Ativar conta'}</button>
          </form>
        ) : (
          <a href={DASHBOARD_URL} style={secondaryButtonStyle}>Acessar dashboard</a>
        )}

        <div style={{ marginTop: '18px', color: '#607089' }}>Já ativou sua conta? <a href={DASHBOARD_URL} style={helperLinkStyle}>Entrar no dashboard</a></div>
        <div style={{ marginTop: '10px' }}><Link to="/" style={helperLinkStyle}>Voltar para o site</Link></div>
      </section>
    </main>
  );
}

export default AtivarConta;
